import React from 'react';
import styled from 'styled-components';
import { config } from './../../config/config';
import { CalculatorSection } from './../Calculators/Sections';
import { TextInput, RangerInput, InfoTip } from './../Form/index';
import { toPounds } from './../../services/Formats';
import {ErrorBox} from "../PartialRepayment/Sidebar";

const { colorConfig } = config();

export const GreenLabel = styled.div`
  font-family: 'Ubuntu',arial;
  font-weight: bold;
  color: ${colorConfig.main}
`;

export const HousePriceChange = ({ input, onChangeInput }) => (
  <CalculatorSection style={{ margin: '30px auto', width: '80%' }}>
    <div className="label" style={{ textAlign: 'center', fontSize: 14 }}>
      <strong>Select an average annual % house price decrease or increase over 15 years</strong>
      <br />
      and see how that can affect the equity protected in your home:
    </div>
    <div style={{ paddingTop: 10 }}>
      <RangerInput
        className="ranger"
        value={input.futureHousePricePct} min={-5} max={5} div={4} type='float'
        inactiveColor='#bbbbbb' withLabel={true} suffix="%"
        onChange={val => { onChangeInput('futureHousePricePct', val) }}
      />
    </div>
  </CalculatorSection>
);

export const ClientDetails = ({ input, output, onChangeInput }) => (
  <CalculatorSection>
    <div className="title">Client Details</div>
    <div className="section-row" style={{ paddingTop: 10 }}>

      <div className="column-icon clr1">
        <img src="images/icon_plan.png" style={{height: 40}} />
      </div>


      <div className="pad column-cell">
        <div className="label">Horizon Plan</div>

        <div>
          <select style={{ width: 154, fontFamily: 'Ubuntu', border: '2px #707070 solid', borderRadius: '5px', height: '36px' }} value={input.horizonPlan} onChange={val => { onChangeInput('horizonPlan', val.target.value); }} name="horizonPlan" id="horizonPlan">
            <option value="300">Horizon 300</option>
            <option value="350">Horizon 350</option>
            <option value="400">Horizon 400</option>
            <option value="450">Horizon 450</option>
            <option value="500">Horizon 500</option>
            <option value="550">Horizon 550</option>
            <option value="600">Horizon 600</option>
            <option value="620">Horizon 620</option>
            <option value="680">Horizon 680</option>
            <option value="700">Horizon 700</option>
            <option value="730">Horizon 730</option>
            <option value="780">Horizon 780</option>
            <option value="800">Horizon 800</option>
          </select>
        </div>

      </div>
    </div>
    <div className="section-row">

      <div className="column-icon clr1">
        <img src="images/icon-people.png" />
      </div>


      <div className="pad column-cell">
        <div className="label">Age <small style={{ fontSize: '0.66rem'}}>(youngest if in couple)</small></div>

        <div style={{ paddingLeft:16, paddingRight: 16 }}>
          <RangerInput
            className="ranger"
            style={{ width: 120 }}
            value={input.clientAge} min={55} max={84} withLabel={true}
            color={colorConfig.main} inactiveColor='#bbbbbb'
            onChange={val => { onChangeInput('clientAge', val) }}
          />
        </div>

      </div>
    </div>
    <div className="section-row">
      <div className="column-icon clr1">
        <img src="images/icon-house-pounds.png" />
      </div>

      <div className="pad column-cell">
        <div className="label">Value of home</div>
        <div>
          <TextInput
            width={150} style={{ textAlign: 'right' }}
            type="currency" prefixes="&pound;" value={input.housePrice}
            onChange={val => { onChangeInput('housePrice', val) }} />
        </div>
      </div>
    </div>

    {(input.housePrice > 5100000) ? (
      <div className="section-row">
        <div style={{ marginLeft: 20, marginRight: 20 }}>
          <ErrorBox style={{ fontSize: 14, marginTop: 0 }}>
            The maximum allowed value has been exceeded, please enter a value less than
            £5,100,000
          </ErrorBox>
        </div>
      </div>
    ): false}
    <div className="section-row">
      <div className="column-icon clr1">
        <img src="images/icon-pounds-up.png" />
      </div>
      <div className="pad column-cell">
        <div className="label">
          Maximum loan available
        </div>
        <GreenLabel style={{ paddingRight: 10 }}>
          {toPounds(output.maxLoan)}
        </GreenLabel>
      </div>
    </div>
    <div className="section-row">
      <div className="column-icon clr1">
        <img src="images/icon-pounds.png" />
      </div>
      <div className="pad column-cell">
        <div className="label">
          Total equity released
        </div>
        <div>
          <TextInput
            width={150} style={{ textAlign: 'right' }}
            type="currency" prefixes="&pound;"
            value={input.totalEquityReleased}
            onChange={val => { onChangeInput('totalEquityReleased', val) }}
          />
        </div>
      </div>
    </div>

    {(input.totalEquityReleased > output.maxLoan) ? (
      <div className="section-row">
        <div style={{ marginLeft: 20, marginRight: 20 }}>
          <ErrorBox style={{ fontSize: 14, marginTop: 0 }}>
            The maximum loan your client can borrow is {toPounds(output.maxLoan)}
          </ErrorBox>
        </div>
      </div>
    ): false}

    <div className="section-row">
      <div className="column-icon clr1">
        <img src="images/icon-loan-taken.png" />
      </div>
      <div className="pad column-cell">
        <div className="label">
          % of loan taken
        </div>
        <GreenLabel style={{ paddingRight: 10 }}>
          {(!isNaN(parseInt(100 - 100 * output.offeredNotTaken, 10))) ? (
            <span>{parseInt(100 - (100 * output.offeredNotTaken), 10)}%</span>
          ): false}
        </GreenLabel>
      </div>
    </div>

    <div className="section-row">
      <div className="column-icon clr1">
        <img src="images/icon-pct-protected.png" />
      </div>
      <div className="pad column-cell">
        <div className="label">
          % of equity protected
          <InfoTip value="Inheritance Protection is capped at 50%" />
        </div>
        <GreenLabel style={{ paddingRight: 10 }}>
          <span>{Math.min(100 * output.offeredNotTaken,
            (input.productChoice === 'prime') ? 100 : 50)}%</span>
        </GreenLabel>
      </div>
    </div>


    {/*<div className="section-row">*/}
    {/*  <div className="column-icon clr1">*/}
    {/*    <img src="images/icon-house-pct.png" />*/}
    {/*  </div>*/}
    {/*  <div className="pad column-cell">*/}
    {/*    <div className="label">*/}
    {/*      Annual % house<br />price change*/}
    {/*    </div>*/}
    {/*    <div style={{ paddingLeft:16, paddingRight: 16 }}>*/}
    {/*      <RangerInput*/}
    {/*        className="ranger"*/}
    {/*        style={{ width: 120 }}*/}
    {/*        value={input.futureHousePricePct} min={-5} max={5} div={4} type='float'*/}
    {/*        color={colorConfig.main} inactiveColor='#bbbbbb' withLabel={true} suffix="%"*/}
    {/*        onChange={val => { onChangeInput('futureHousePricePct', val) }}*/}
    {/*      />*/}
    {/*    </div>*/}
    {/*  </div>*/}
    {/*</div>*/}

  </CalculatorSection>
);



// WEBPACK FOOTER //
// ./src/components/GuaranteedInheritance/Panel.js